require('lib/browser_required')('lib/marionette')

// have to require lib/backbone before marionette, so marionette picks up our
// modifications
require('lib/backbone')

const _ = require('lib/underscore')
const Marionette = require('backbone.marionette')
const BackboneStyles = require('lib/backbone_styles')
const log = require('log').create('marionette') // eslint-disable-line

if (__DEBUG__) require('./debug/marionette_view_count')

// insert & remove styles when Objects are created and destroyed
function modifyObject(ObjectClass) {
    return ObjectClass.extend({
         
        constructor: function constructor(options = {}) {
            BackboneStyles.addStyles.call(this, this.styles)
            BackboneStyles.addStyles.call(this, options.styles)

            BackboneStyles.insertStyles.apply(this)
            this.once('before:destroy', BackboneStyles.removeStyles, this)

            ObjectClass.apply(this, arguments)
        },
    })
}
Marionette.MnObject = modifyObject(Marionette.MnObject)

// allow for behaviors in View.options
function modifyView(ViewClass) {
    return ViewClass.extend({
         
        constructor: function constructor(options = {}) {
            if (options.behaviors) {
                // allow for behaviors to be passed in at view instantiation time
                const view_behaviors = _.result(this, 'behaviors') || {}
                const options_behaviors = _.result(options, 'behaviors') || {}
                this.behaviors = _.extend(view_behaviors, options_behaviors)
            }

            ViewClass.apply(this, arguments)
        },

        destroy() {

            // override destroy so that when called inside a drilldown, we just
            // trigger 'drillup' event instead. DrilldownView will destroy us after
            // animating out

            if (this.isInDrilldown) {
                this.trigger('drillup')
            } else {
                ViewClass.prototype.destroy.apply(this, arguments)
            }
        },

        // this method needs to be provided/overridden by the parent view
        // if called when not provided, we throw an error
        showDrilldown() {
            if (__DEBUG__) {
                throw new Error('showDrilldown method was not provided by parent')
            }
        },
    })
}
Marionette.View = modifyView(Marionette.View)

// other modifications
require('lib/marionette_serialize')

module.exports = Marionette
